import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-12 col-xxl-12 col-sm-12 mb-10" }
const _hoisted_3 = { class: "card mb-25 border-0 rounded-0" }
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_5 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_6 = { class: "table" }
const _hoisted_7 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_10 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[1] || (_cache[1] = _createElementVNode("h4", { class: "position-relative text-black fw-bold mb-10" }, "Informations générales", -1)),
            _createVNode(_component_router_link, {
              to: "/transactions/liste-transactions",
              class: "btn btn-primary transition border-0 lh-1 fw-medium"
            }, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createElementVNode("i", { class: "flaticon-left-arrow lh-1 me-1 position-relative top-2" }, null, -1),
                _createElementVNode("span", { class: "position-relative" }, null, -1),
                _createTextVNode("Retour")
              ])),
              _: 1
            })
          ]),
          _createElementVNode("table", _hoisted_6, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _cache[2] || (_cache[2] = _createElementVNode("td", null, "Date", -1)),
                _createElementVNode("td", null, _toDisplayString(_ctx.transaction?.dateTransaction), 1)
              ]),
              _createElementVNode("tr", null, [
                _cache[3] || (_cache[3] = _createElementVNode("td", null, "Reference", -1)),
                _createElementVNode("td", null, _toDisplayString(_ctx.transaction?.reference), 1)
              ]),
              _createElementVNode("tr", null, [
                _cache[4] || (_cache[4] = _createElementVNode("td", null, "Motif", -1)),
                _createElementVNode("td", null, _toDisplayString(_ctx.transaction?.motif), 1)
              ]),
              _createElementVNode("td", _hoisted_7, [
                _cache[5] || (_cache[5] = _createElementVNode("td", null, "Type Opération", -1)),
                (_ctx.transaction?.typeOperation == 'DEBIT')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.separateur(_ctx.transaction?.montant)), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("td", _hoisted_9, [
                (_ctx.transaction?.typeOperation == 'CREDIT')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.separateur(_ctx.transaction?.montant)), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("tr", null, [
                _cache[6] || (_cache[6] = _createElementVNode("td", null, "Type Opération", -1)),
                _createElementVNode("td", null, _toDisplayString(_ctx.transaction?.typeOperation), 1)
              ]),
              _createElementVNode("tr", null, [
                _cache[7] || (_cache[7] = _createElementVNode("td", null, "Solde", -1)),
                _createElementVNode("td", null, _toDisplayString(_ctx.transaction?.solde), 1)
              ]),
              _createElementVNode("tr", null, [
                _cache[8] || (_cache[8] = _createElementVNode("td", null, "Statut", -1)),
                _createElementVNode("td", null, _toDisplayString(_ctx.transaction?.statut), 1)
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}